"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bignumber_js_1 = require("bignumber.js");
const account_1 = require("../../account");
const js_getFeesForTransaction_1 = __importDefault(require("./js-getFeesForTransaction"));
/**
 * Returns the maximum possible amount for transaction
 *
 * @param {Object} param - the account, parentAccount and transaction
 */
const estimateMaxSpendable = ({ account, parentAccount, }) => __awaiter(void 0, void 0, void 0, function* () {
    const a = (0, account_1.getMainAccount)(account, parentAccount);
    const fees = yield (0, js_getFeesForTransaction_1.default)();
    return bignumber_js_1.BigNumber.max(0, a.spendableBalance.minus(fees));
});
exports.default = estimateMaxSpendable;
//# sourceMappingURL=js-estimateMaxSpendable.js.map